import { render, staticRenderFns } from "./public-episodes.vue?vue&type=template&id=b6c68b94&scoped=true&lang=html&"
import script from "./public-episodes.vue?vue&type=script&lang=js&"
export * from "./public-episodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c68b94",
  null
  
)

export default component.exports